<div class="container">
<div class="login-menubar">
    <nav>
        <div class="wrapper">
            <input type="radio" name="slider" id="menu-btn">
            <input type="radio" name="slider" id="close-btn">
            <ul class="nav-links">
                <label for="close-btn" class="btn close-btn"><i class="nav-icon feather icon-arrow-left" ></i></label>
                <li><a href="#">Home</a></li>
                <li><a href="#">About</a></li>
                <li class="dropdown">
                    <a href="#" class="desktop-item">Services <img src="assets/images/dropdown.png"></a>
                    <input type="checkbox" id="showDrop">
                    <label for="showDrop" class="mobile-item">Services <img src="assets/images/dropdown.png"></label>
                    <ul class="drop-menu">
                        <li><a href="#">Web Design</a></li>
                        <li><a href="#">Development</a></li>
                        <li><a href="#">SEO</a></li>
                    </ul>
                </li>
                <li><a href="#">Portfolio</a></li>
                <li><a href="#">Contact</a></li>
            </ul>
            <label for="menu-btn" class="btn menu-btn"><i class="nav-icon feather icon-menu" ></i></label>
        </div>
    </nav>
</div>
</div>
<div class="login-video-section">
<video src="assets/digidend-banner-video.mp4" autoplay="true" muted="" loop="" playsinline=""  class="video-bg">
</video>
</div>
<div class="auth-full-height login-box-detail">
    <div class="container">
    <div class="row m-0">
        <div class="col p-0 auth-full-height">
            <div class="d-flex justify-content-center flex-column h-100  py-3">
                <div></div>
                <div class="w-100 ">
                    <p class="text-white lead tagline-text">What resides beyond this page is the list of the closest possible people who are willing to do business with you.</p>
                    <h3 class="display-4 text-white tagline-text">- Bijoy Patel</h3>
                </div>
                
            </div>
        </div>
        <div class="col-12 p-0 auth-full-height" style="max-width: 450px;">
            <div class="d-flex h-100 align-items-center p-5">
                <div class="w-100 right-login-box bg-white">
                    <div class="mt-0 formBox">
                        <div class="alert alert-danger" *ngIf="showResult">

                        </div>
                        <form [formGroup]="formGroup" *ngIf=false (submit)="login()">
                            <div class="form-group mb-3">
                                <label class="form-label">Email</label>
                                <input 
                                    type="text" 
                                    class="form-control no-validation-icon no-success-validation" 
                                    formControlName="email"
                                >
                            </div>
                            <div class="mb-3 ">
                                <label class="form-label d-flex justify-content-between">
                                    <span>Password</span>
                                    <a class="text-primary font" routerLink="/forgot-password">Forget Password?</a>
                                </label>
                                <div class="form-group input-affix flex-column">
                                    <label class="d-none">Password</label>
                                    <input 
                                        [type]="showPassword ? 'text' : 'password'" 
                                        class="form-control no-validation-icon no-success-validation" 
                                        formControlName="password"
                                    >
                                    <i 
                                        class="suffix-icon feather cursor-pointer text-dark" 
                                        [ngClass]="showPassword ? 'icon-eye-off' : 'icon-eye'" 
                                        (click)="onShowPasswordClick()"
                                    >
                                    </i>
                                </div>
                            </div>
                            <button class="btn btn-primary w-100" type="submit">Log In</button>
                        </form>
                       
                        <form [formGroup]="loginForm" (submit)="sendOtp()" class="login-form">
                            <div class="form-group mb-3">
                              <!--  <label class="form-label">Contact No</label>-->
                                
                                <input type="text" formControlName="contact_no" [disabled]="otpBox"
                                    class="form-control no-validation-icon no-success-validation" placeholder="Contact No">
                                <button *ngIf="!otpBox" class="btn btn-primary w-100 svgIcon" type="submit"><svg fill="#000000" width="800px" height="800px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-iconid="357593" data-svgname="Comment verify"><path d="M15.29,8.85l-4.73,4.74L8.71,11.73a1,1,0,0,0-1.42,1.42l2.56,2.56a1,1,0,0,0,1.42,0l5.44-5.44a1,1,0,1,0-1.42-1.42ZM12,2A10,10,0,0,0,2,12a9.89,9.89,0,0,0,2.26,6.33l-2,2a1,1,0,0,0-.21,1.09A1,1,0,0,0,3,22h9A10,10,0,0,0,12,2Zm0,18H5.41l.93-.93a1,1,0,0,0,0-1.41A8,8,0,1,1,12,20Z"></path></svg></button>
                            </div>
                        </form>
                        <form [formGroup]="otpForm" *ngIf="otpBox" (submit)="loginViaOtp()">
                            <div class="form-group mb-3">
                                <label class="form-label">OTP</label>
                                <input type="text" formControlName="otp"
                                    class="form-control no-validation-icon no-success-validation">
                                <button class="btn btn-primary w-100 svgIcon" type="submit"><svg width="800px" height="800px" viewBox="0 0 32 32" enable-background="new 0 0 32 32" id="Editable-line" version="1.1" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" data-iconid="422515" data-svgname="Dot menu more 2"><circle cx="16" cy="16" fill="none" id="XMLID_878_" r="2" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"></circle><circle cx="6" cy="16" fill="none" id="XMLID_879_" r="2" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"></circle><circle cx="26" cy="16" fill="none" id="XMLID_880_" r="2" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"></circle></svg></button>
                            </div>
                        </form>
                    </div>
                    <div class="d-flex justify-content-center">
                        <!--<logo class="text-center"></logo>-->
                         <img src="assets/images/logo/CompuBrain.png" class="digidend-logo">
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 copywrite-footer ">
                    <span class="text-white poweredBy">© 2025 Powered by <a href="https://compubrain.com/" target="_blank"><img src="assets/images/compubrain-logo-white.svg"></a></span>
                    <div>
                        <a href="" class="text-white text-link me-3">Legal</a>
                        <a href="" class="text-white text-link">Privacy</a>
                    </div>
                </div>
    </div>
    </div>
</div>